// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".max-width__BusinessProfile_1gEcQ {\n  max-width: 1140px;\n  width: 100%;\n  margin: 0 auto;\n}\n.headline-wrap__BusinessProfile_1TdtK {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.btns-wrap__BusinessProfile_2eYpo {\n  display: flex;\n}\n.btns-wrap__BusinessProfile_2eYpo button {\n  margin: 0;\n  margin-right: 15px;\n}\n", ""]);
// Exports
exports.locals = {
	"max-width": "max-width__BusinessProfile_1gEcQ",
	"maxWidth": "max-width__BusinessProfile_1gEcQ",
	"headline-wrap": "headline-wrap__BusinessProfile_1TdtK",
	"headlineWrap": "headline-wrap__BusinessProfile_1TdtK",
	"btns-wrap": "btns-wrap__BusinessProfile_2eYpo",
	"btnsWrap": "btns-wrap__BusinessProfile_2eYpo"
};
module.exports = exports;
